export const ICON_OPTIONS = [
  '📊', '📈', '📉', '🔔', '⚡', '🔥', '⭐', '🎯', '🛡️', '🔧',
  '📋', '📁', '🗂️', '🏢', '👥', '🖥️', '🌐', '📡', '🔍', '📌',
  '🚨', '💡', '📝', '✅', '❌', '⏰', '🔒', '📦', '🎉', '💼',
];
